export interface ProviderRateLimit {
  limit: number | null;
  remaining: number | null;
  resetsAt: string | null;
  policy: string;
}

export const unknownRateLimit = (): ProviderRateLimit => ({ limit: null, remaining: null, resetsAt: null, policy: 'Not published' });
